import { useState } from "react";
import ModalBase from "./ModalBase";
import TextInput from "../forms/TextInput";
import SelectInput from "../forms/SelectInput";
import SliderInput from "../forms/SliderInput";
import { formatCurrency } from "../../js/utils/formatters";

export default function BuyerInfoModal({ isOpen, onClose, onSubmit, initialValues = {} }) {
  const [form, setForm] = useState({
    householdSize: initialValues.householdSize || "2",
    timeline: initialValues.timeline || "",
    currentHousing: initialValues.currentHousing || "",
    budget: initialValues.budget || 650000,
  });

  function update(event) {
    const { name, value } = event.target;
    setForm((current) => ({ ...current, [name]: value }));
  }

  function handleSubmit(event) {
    event.preventDefault();
    onSubmit(form);
  }

  return (
    <ModalBase isOpen={isOpen} title="Tell Us About Your Search" onClose={onClose}>
      <form onSubmit={handleSubmit}>
        <SelectInput
          label="Buying timeline"
          name="timeline"
          value={form.timeline}
          onChange={update}
          options={[
            { value: "0-3", label: "0–3 months" },
            { value: "3-6", label: "3–6 months" },
            { value: "6-12", label: "6–12 months" },
            { value: "12+", label: "12+ months / exploring" },
          ]}
        />
        <SelectInput
          label="Current housing"
          name="currentHousing"
          value={form.currentHousing}
          onChange={update}
          options={[
            { value: "renting", label: "Renting" },
            { value: "own", label: "Own a home to sell" },
            { value: "family", label: "Living with family" },
            { value: "other", label: "Other" },
          ]}
        />
        <TextInput
          label="Household size"
          name="householdSize"
          type="number"
          value={form.householdSize}
          onChange={update}
        />
        <SliderInput
          label="Target budget"
          name="budget"
          min={200000}
          max={2500000}
          step={25000}
          value={Number(form.budget)}
          onChange={update}
          formatValue={formatCurrency}
        />
        <button type="submit" className="primary-btn btn-block">
          Save buyer info
        </button>
      </form>
    </ModalBase>
  );
}
